(function () {
    'use strict';

    angular
        .module('app')
        .controller('sidebar', sidebar);

    sidebar.$inject = [
        '$state',
        '$window',
        'columnFactory',
        'searchService',
        '$rootScope',
        'gridDataService',
        '$uibModal',
        '$timeout',
        'favoritesService',
        'savedSearchService',
        '$localStorage',
        'lastSearchService',
        'storageService',
        '$filter',
        'sidebarservice',
        '$scope',
        '$mdToast',
        'workAreaService',
        'libraryService',
        '$location',
        'ftsService',
        'loginService',
        'fileGuideService',
        'ddService',
        '$q', 'breadCrumbService', 'zcs', 'clientService'];

    function sidebar(
        $state,
        $window,
        columnFactory,
        searchService,
        $rootScope,
        gridDataService,
        $modal,
        $timeout,
        favoritesService,
        savedSearchService,
        $localStorage,
        lastSearchService,
        storageService,
        $filter,
        sidebarservice,
        $scope,
        $mdToast,
        workAreaService,
        libraryService, $location, ftsService, loginService, fileGuideService, ddService, $q, breadCrumbService, zcs, clientService) {


        /* jshint validthis:true */
        var vm = this;
        vm.searchFields = [''];
        vm.searchFieldSelected = {};
        vm.fieldFilter = "";
        vm.processing = false;
        vm.searchInputModel = "";
        vm.columnFactory = columnFactory;
        vm.criteria = [{
            schemaID: 'SCHEMA_S_LONGNAME',
            valueStr: '',
            startDate: "sample string 3",
            endDate: "sample string 4",
            searchOp: 0
        }];
        vm.loadingIndicator = false;
        vm.favoritesService = favoritesService;
        vm.savedSearchService = savedSearchService;
        vm.ddService = ddService;
        vm.savedSearchList = [];
        vm.localStorage = $localStorage;
        vm.gridDataService = gridDataService;
        vm.availableColumns = [];
        vm.sidebarservice = sidebarservice;
        vm.state = $state;
        vm.libraryService = libraryService;
        vm.fileGuideService = fileGuideService;
        vm.loginService = loginService;
        vm.searchBoxDisplay = "";
        vm.editMode = false;
        vm.disableAddToFavorite = true;
        $scope.showDropDown = false;
        var favRemoveItemsDisabled = true;
        var oldName = "";
        vm.clientService = clientService;
        // ************************************************
        // QuickSearch - Start
        // ************************************************



        //keyboard support listener for a selection is change
        vm.onFieldSelectionChanged = function (currentSelected) {
            //reset all selections
            vm.ftsSearchSelected = false;
            angular.forEach(vm.currentFields, function (item) {
                item.active = false;
            });

            //if the selection is the first one, select fts otherwise select an item from the currentfields
            if (currentSelected > 0) {
                vm.currentFields[currentSelected - 1].active = true;
            }
            else {
                vm.ftsSearchSelected = true;
            }
        }

        //keyboard support listener for when an item is selected
        vm.onFieldSelectionMade = function () {
            var selected = $filter('filter')(vm.currentFields, { active: true });
            if (selected.length > 0) {
                vm.fieldSelected(selected[0]);
            }
            else {
                vm.fieldSelected('FTS');
            }

        }

        sidebarservice.getDatabaseType().then(function (resp) {
            //console.log("database type is", resp);
        });

        vm.searchFieldLabel = loginService.resourceStrings["SEARCH_FIELD"]; // Not working in HTML like: {{vm.loginService.resourceStrings["SEARCH_FIELD"]}}

        //check fts status
        sidebarservice.checkFTS();

        // method performs a search
        vm.search = function (criteria) {
            // Paul.Ligowski 2017-05-08 Need to leave active to test with toolbar. // setInactive();
            fileGuideService.clearSelectedNodes();
            searchService.searchCriteria = (criteria === undefined) ? vm.criteria : criteria;
            vm.processing = true;
            gridDataService.genericDataService = searchService;
            //must identify the service in order to inject the correct one.
            gridDataService.serviceIdentifier = "searchService";
            //reset, since it's a new search
            gridDataService.totalRecords = 0;
            gridDataService.processing = true;

            //callback to be notified when the grid is done and clear the search criteria at the service level
            var callBack = function () {
                //Example on how to do callbacks
                gridDataService.unRegister(callBack);
            }

            //register the callback with the gridDataService
            gridDataService.register(callBack);
            var getType = {};
            //timeout so the overlay can be displayed and not the previous records.
            $timeout(function () {
                $state.go('layout.results.grid').then(function () {
                    if (getType.toString.call(gridDataService.reloadGrid) === '[object Function]') {
                        gridDataService.reloadGrid();
                    }
                });
            }, 0);


            //$rootScope.$broadcast('grid:reload');
        };

        //This section handles the validation of the input entered in the quicksearch depending on the field selected.
        var isNumeric = function (input) {
            return (input - 0) == input && ('' + input).trim().length > 0;
        }
        vm.qsInputChanged = function () {
            //ensure the popup is hidden
            vm.showCharWarning = false;

            //function removes the last charachter entered.
            var removeLastChar = function () {
                if (vm.searchInputModel.length > 1) {
                    vm.searchInputModel = vm.searchInputModel.slice(0, vm.searchInputModel.length - 1);
                }
                else {
                    vm.searchInputModel = "";
                }
            }

            //method to display the message that the character is not allowed.
            var showMessage = function () {
                vm.showCharWarning = true;
                removeLastChar();
                $timeout(function () {
                    vm.showCharWarning = false;
                }, 2000);
            }

            //fts field
            if (vm.searchFieldSelected == "FTS") {
                //TD 07-14-2021 (27369) Don't disallow leading wildcards in FTS.
                //if (vm.searchInputModel.indexOf("*") == 0 || vm.searchInputModel.indexOf("?") == 0) {
                //    showMessage();
                //}
                return;
            }


            if (vm.searchInputModel.length > 0) {

                switch (vm.searchFieldSelected.fieldType) {
                    case 3:
                    case 4:
                    case 8:
                        //check the last character entered
                        if (!isNumeric(vm.searchInputModel[vm.searchInputModel.length - 1])) {
                            var charsToSearch = [">", "<", "!"];
                            //check if any of the allowed characters was entered
                            if (charsToSearch.indexOf(vm.searchInputModel[vm.searchInputModel.length - 1]) > -1) {
                                //check if it's the first character entered
                                if (vm.searchInputModel.length == 1) {
                                    //let it go
                                    return;
                                }

                            }
                            showMessage();
                        }
                        break;
                    default:
                        //never allow a wildcard for oracle dbs
                        if (vm.searchInputModel.indexOf("?") > -1 && vm.sidebarservice.databaseType == 2) {
                            showMessage();
                            return;
                        }
                        var charsToSearch = [">", "<", "!", "*"];
                        //check if any of the allowed characters was entered
                        var char = vm.searchInputModel[vm.searchInputModel.length - 1];
                        if (charsToSearch.indexOf(char) > -1) {
                            //check if it's the first character entered
                            if (vm.searchInputModel.length == 1) {
                                //let it go
                                return;
                            }
                            else {
                                if (char === "*" && sidebarservice.databaseType === 1) {
                                    break;
                                }
                                showMessage();
                            }

                        }
                        break;
                        



                }
            }
        }

        vm.searchButtonClicked = function () {
            vm.criteria[0].valueStr = vm.searchInputModel;
            vm.searchInputModel = "";
            if (vm.searchFieldSelected == "FTS") {
                vm.fullTextSearch();
            }
            else {
                vm.search();
            }
        }

        vm.inputKeyDown = function (e) {
            if (e.keyCode == 13) {
                if (vm.searchInputModel.length > 0) {
                    vm.criteria[0].valueStr = vm.searchInputModel;
                    vm.searchInputModel = "";
                    if (vm.searchFieldSelected == "FTS") {
                        vm.fullTextSearch();
                    }
                    else {
                        vm.search();
                    }
                }

            }
        }

        //gets the available columns to display in the select box
        vm.columnFactory.getAvailableColumns().then(function (response) {
            var index = 0;
            angular.forEach(response.data, function (item, key) {
                item.index = index;
                index++;
            });
            //remove adept version
            vm.availableColumns = $filter('filter')(response.data, function (item) {
                item.special = false;
                if (item.schemaID == "SCHEMA_S_VERSION") {
                    return false;
                }
                return true;
            });

            //set filename as the default selection
            var lastField = storageService.qsField;
            angular.forEach(response.data, function (value, keys) {

                if (value.schemaID == lastField) {
                    vm.searchFieldSelected = vm.columnFactory.availableColumns[keys];
                    //vm.searchBoxDisplay = "Search by " + vm.searchFieldSelected.displayName;
                    vm.searchBoxDisplay = loginService.resourceStrings["SEARCH_BY"] + " " + vm.searchFieldSelected.displayName;
                }
            });

            vm.currentFields = vm.availableColumns;
            if (lastField == "FTS") {
                vm.fieldSelected("FTS");
            }
            else {
                var fieldItem = $filter('filter')(vm.currentFields, { schemaID: lastField })[0];
                if (fieldItem) {
                    vm.fieldSelected(fieldItem);
                }
            }
        });

        //listener for the select box to update the criteria
        vm.selectedSearchFieldChanged = function (field) {
            if (field == "FTS") {
                vm.criteria[0].schemaID = "FTS";
            }
            else {
                vm.criteria[0].schemaID = vm.searchFieldSelected.schemaID
            }

        };

        //ensure quicksearch is enabled
        $timeout(function () {
            vm.sidebarservice.processing = false;
        }, 1000);

        vm.toggleDropDown = function () {
            vm.fieldFilter = "";
            vm.currentFields = vm.availableColumns;
            //this array will keep track of the active items for keyboard support
            //rest of the fields
            vm.showDropDown = !vm.showDropDown;
        }

        vm.currentFields = vm.availableColumns;
        vm.filterChanged = function () {
            var filtered = $filter('filter')(vm.availableColumns, { displayName: vm.fieldFilter });
            vm.currentFields = filtered;
        }

        vm.fieldSelected = function (item) {
            if (item == "FTS") {
                vm.searchBoxDisplay = loginService.resourceStrings["FULL_TEXT_SEARCH"];
                storageService.qsField = item;
            }
            else {
                //vm.searchBoxDisplay = "Search by " + item.displayName;
                vm.searchBoxDisplay = loginService.resourceStrings["SEARCH_BY"] + " " + item.displayName;
                storageService.qsField = item.schemaID;
            }

            $scope.focusSearch();
            vm.showDropDown = false;
            vm.searchFieldSelected = item;
            vm.criteria[0].schemaID = item.schemaID
            if (vm.searchInputModel != "") {
                vm.criteria[0].valueStr = vm.searchInputModel;
                vm.searchInputModel = "";
                //removeFileGuide();
                if (item == 'FTS') {
                    vm.fullTextSearch();
                    return;
                }
                else {
                    vm.search();
                }

            }
        }

        // method performs a full text search
        vm.fullTextSearch = function () {
            ftsService.searchCriteria = vm.criteria;
            vm.processing = true;
            //must identify the service in order to inject the correct one.
            gridDataService.serviceIdentifier = "ftsService";

            //callback to be notified when the grid is done and clear the search criteria at the service level
            var callBack = function () {
                //Example on how to do callbacks
                gridDataService.unRegister(callBack);
            }
            ftsService.ftsSearchId = "";
            //register the callback with the gridDataService
            gridDataService.register(callBack);
            gridDataService.processing = true;
            $timeout(function () {
                $state.go('layout.results.grid').then(function () {
                    gridDataService.reloadGrid();
                });
            });

        };
        // ************************************************
        // QuickSearch - End
        // ************************************************


        // ************************************************
        // MenuView - Start
        // ************************************************
        var homeIcon = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH4AcGFCIXcpX6pQAAAodJREFUSMftlT9oFFEQh7+3d+YSSYx/0CLiebEIhCA2oo3KPBHbEIKFiCKJguWBKKkEQbCwiWBpp5LCWgyovAERC0ULi1iZzQmKKIma5M6Y3K1F3sbN6l0S0zrNLvtmv9/s7O/Ng1WEiI2vORHbnHyWvk+/Z1hliNhW4DZggEFVNxODVR0idg+wAYiAeVU3jk9esXIgAzwCpoEqsA045kGI2Bbgq+dlgHfAcVU3HjSCqzqAZuAxsAD0AyeACvAE2OjTm4AasEPVZYD4awgawUXsbuA18AnoVXULqq4K9AHvgVciNu/hBmjziChmBQ3g24FnwH3glKqriNh4vQKcBkZ8zmYg59u3LP4Q8PA88AYYUXVX4hdVXdw2gJqquwrcA14AParuQ12BhBUP+bbcUnWXYvDfCvHXIeAm8FTEHk5wzZJAoi37gVHggqq71sjjyTVVdx04D4yK2G7gM1BOJ1sRWxWxZ1cCN9iIZzzjYDphQMR+E7H9rDNEbJ+InRKx5wAyInYAuAEcUXUaVxSG4VrBhGFIGIZvC4XOB8DdQqFzKgCGgJNAd/oHAuSHo7rQ5FrKCAeAXuCy8ep7gZeqLpcGlIqG/HCUnDPxiPlRKpqJOCfxJe1+bHSouo/ZxKwppyv08BZgzENjW9e8WC4JT8QckK07KlKxNGdKRZMtFU0WKACmUfvq7uQ6kZwzAK0rTeK1Cvxz/BdYv0C1adH7Ueb3IRIFi/d1LLrMWtmESxCxHd4hi+oLldqsu9j+ZV8xaJt42LOrd3ArRMyM3SnM7rRG5GiXqc1HUZA1if3RnjjhlsBdwHOvnirLmFpT6xYzX/5uiGoAkQmCKNuyKfg5PVnH0nP+AJr8BcX9Aj9+rgxjAAAAAElFTkSuQmCC";
        var favoritesIcon = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH4AYWFBkZxOZGtQAABBNJREFUSMe1ln9oVWUYxz/v+XG9XN1m2zRTFyOjhXdkSYapzXNrxVwll2ISLCbFlIJS7Por0LLoL+OWRZjEtB9oUfrHrcmV1HFebaJLCG3MSFq4CdZctrlfd3fn3PP2h+eOqZsuowcOvHzf532+z6/3fY5ghFhWBCltLCsigFnAe8BJ4H0p7T5fZyqwBQgA66W0//bxScAKoAh4W0q7G0AwilhW5C1gJfAZMMcnew3IB94EjgEu8CSwAegA3gAGgIvAYuB14MthAidhYZgUNJ/nlVe/EhuF4F4p7TbLigSACuBz36EocNQ/Ng/YAxQDL/kOKWABsAtYqGUJzKjE87yn8nMyK4ImQSntNgApZw1JaX8HlAD5UtoS8ABPSrsJmAtMltKu86PKAL8AvYAwnISVSzpgqq68lNIvrJkyo3/G9Lx8+vdUFIbyhlzX/a3HjD7mSdlwcWSdRqx7RsFFNv3CSViSYHqOMN20mOBMFaYjujpD5AVFJwNBpTwtYkblGf6FWFZkCnAQqDDUkFmu6Zl9YuLgUvSMUJ7G5Pw0qmdSynWCz78zYWf7R/XnckH0ArmAdgPbLtC3L755GDACyw65qe3Lqkz+aBO5/XeAQKUC0BesiYS+P1WdObYXRD9QC3wBFI5hXACtwMsjQQPAmPbXfejeRK8vpISntWoB9+6Mrh4/XimOVNc3vuB3Rq/f5/pNIugHglngSriaN0855u+Ga84sWK0vbDgduKTrqgJAIVJAyu+cQX99o09dFwFwiBSfiOdsb1FZpGhTQoTKN2ZW7j5wYEa3q+p8r24tRU7CwozK1mFAAyOALpYe/an+3GG9u/nH/5Qiw4zKsVqNp4sDGeDPEXDHONuUq2vwP8q4CcLJGOFkbMy9scQYj+GWyni2iAXhZGypQi2+AggJ7G+pjHdeo3tLKVoLnE177s6iUEHNnaEpNYMZZ5eCn8PJ2CqAlsr4ddHclMA/9A2wNeU5t334wHL2l22gvmw9H8+rRcA0YFs4Gdud1R8XQY5sz6ZoO1CV9hxW3BVhfuE9lDVs4eFDmyjJmU518SI8pQRQHU7GNoeTMTEugnpamX1wXRGwHFCu5/Ho7aV83X6cC6kuLjsD1LUeJpxbhC6GzdT6U++GBMNv+Zkn3j0PHAGELjSau9spn1bKBM1gyHOJznyI9oFOMnjZs40tlfFLQF/WjhjlkphAkz+8v7WlXVuajJ0EHvRQJBatJc8MYWo6HYOXebFpBz1uCgGnzi8pnz/X2ppAcD/QDDxrjPJX4VhWZLE/7Ds2XtkqA7YJxMpnGuMsKCwB4MSls7heBk1onwJresSSNFZkHZAD/Cql3TtaBMOj75r7YACzgVWeUo8AShPiB2AHcLqlMu7OX13FiQ/2XmXrH8+3p18vJUYiAAAAAElFTkSuQmCC";
        var savedSearchesIcon = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH4AcGFCUByQDZMwAAA2pJREFUSMet1F+IVHUUB/DP3Z0ZW3ctSQ0RWZ9EakMsI3qx7qBFzhou5ItBf/Al0GCX1oKC7aV6qFhaU/oHPhRGkGgDxixBMZceRMmXqEHUCp2nRSzXdHXd2Z3bw9wZZsbdHswDP+65v3vuOed7zvmeIAyzD+Mb3IvY7UuAy3g+iorHwzAriopS+Bqf4Jj/L/0oYGkUFUEKy3Esiopn70CAs2GYXd18kWp+CcPsJhxJynU7EuNmGGaHcAn9qTaDw3gX43cAzTP4KtUUGZZh/E6UKwyzx/BmaiGDvsLwCsxiMulTs76QzGKylBuN5+1BCxbyOI3dbfrR5L94njEtYRBTCwcIGlo2cVJp0zcvkH0H7sL19stWqTYSm8ZxdLXpN5IM6+d6cn5HR3N55kfQ0YCwGddKudEbfYXhdn1JgmgO55PnTCk3+ne7u9R/IPgRp/oKw0/Mo88lNv/g6VJu9FQyGKCUG70lQDwPgi4EpdzodF9huKGjs68wHIhTcan/vdrEjQ8qbd3X4ri5B9fxZBhmuxE3hfoBB/oKw+kmvTvJsOEcSlv3gd6xW3dlCi8li24VKk1TtBMzyWzvxEw8t/hG4ujBhPEbUcUJvFEeCv7oHYuVh4J5hrLGvlncH0XFcwsxqXcs3oHDPZna+9RMCyF2lIeCI4mvtTgRVPLhCuxPba++kM12XsJeFNuCz0RR8XzvWLyxI3Bq+zpeXF+zOPQrR083ZuMKNqw/EJSvrc7uwkgKaaxzsqMLz+EQetoSn/iNNTk+XNbFq4+xZ5xqlY/7+ekCF2vcvQe709e8jT3YlUrq3FmZcHcUFb/D0vlKs+VgnMlctXZRisvTnPurVvyLU/RkGgFgy7cTXjdRfKg+RZP4JWAEKvnwtUo+/KxuXcmHIHNVgODKTeKYkcd5axMbVjIz10yf1r4GiZNV+Bln8Q7GcCE9EG1ra/BJPLqymx0P0BmwvJtwDVsOMV0hCHxUHgoGGwEq+VB6IFLJhxl8iRy6k++70gPRF00BnsL3UKnW6FmN+XQbSxfx7GGzPRnrykPBn+0IpAeiekkeSdbB5xhJD0TTdRKVhwK9Y/FevF//N062y32LVS9Oebmzw0HEdS601KuSDwO1XlzG/gSZ9EDUzNIgIdggNiV7KZqt+mBJxpkzrwQtdP4XSiBTo7aVhcYAAAAASUVORK5CYII=";
        var inboxIcon = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH4AYUEgQaDAfPKgAAAtJJREFUSMfdlk1IVFEUx393Zp45ow0mGJqRY2ZRAwZugiA4tyDDijZRaLgNchHFkJDUQlppCEm07IOCisBaNa3i3WjhIjAIFIqUaRN9kDSV+DUzr0Xv2ev5La468OBx7//j3vPOPffBfx/JdGpVc15EFiMPNfcCqGQ6tQPoAA6408+BHuAt4Piwc0ItYwcXgB4HKImsA2A8N+URO4aae68uxg8tIX4U6AKYys/Qvu0g7dsOMpWf8SBdyXTqyKoMkumUBbQAUYACDqVWMaVWMQUcDxYFWlzsindQAux0gLgVJRYuwgEcIBYuIm5FPZtdLnZlH9n7RrlCnrbEPrbEKsg5eQC6d5/iw/hX+t49wwqF1apSlI8XTQAjVijMzRGb6lg5TZUNNFU2UB0r59aojRUKA4wU/mDnjbD3IqLJZDKI6A2JRG1F/GmmaFxX/wKOTxfy6sWXYXaX1fB5Msv513fJzkyglHJQqquyc+BzTX1deSJRa2UymQlPa7ZMRTTG2IjoOuCVm9Ov4bHJxk/dey/icK7gOKy3igH4OTNJSClQ9FWde9mVqyp5A2wEpoE9xtjDnqbyiUfdg3MD6DHGdnwVdQK4ApS7Q2PA5aHm3kf+dIjos8AlYKsx9i8RPTtRLKIHRPTDAOGfdpBMpzYn06nN/tM+K/KXc1tED4romDegRPQ112BWeKmeExzzc0S0EdHXRXRIiegmoB9oBL4FiwnI+tMVEFVAfJ5y3wAMAieViB4DssDHQG8KAQXgEPADwBg7uNpS4IlrkvdxHaAKKIu4oq3ASMCgBHgMHDbGfuBfns9oP7AJOAb8DBjUAemIu8pvxthf5klBJ3BHRN9b4BxlgdPG2O/n4ZYBhQVPslu+aWA7kHR7jv9JAvXG2P3Bolh2L3JNvgPfF8Ms50ab07C8PC8Vi+CUZzAKtLl5dtboKldAGzAacSvoPnBmjf8XRoHW38/yALNWr1HOAAAAAElFTkSuQmCC";
        var libraryBrowsericon = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH4AYWFA4l7gq+pAAAA0NJREFUSMe9lV+IVFUcxz/nzp1dx21JXVdrl9BwrZeuZT0UtOC5EVcfWuzlgNRDQU+xGL0kRIZISUQSmUL0h1p8bMygKPBI3CPZU2DSMVkwLEy2dts1zba13Zm5vfwmDsNMjUH94HA5M9/z+57f9/6+v6voMqzxZNUEa3wEPADsAjbL32eBl4FjWTWph+cirj/2AW8AR4UoBSaE4JA1vmSNv76MzQPWeGONv2KNX9cGM2SN99b4sY4VaJ22JciqCQAKte9yfe5QNpnMap0Oap2u0jqNBDMFHAB2h2dVu4Rap0NAqbmvF7X6M4P7F/qjFecOzD13/lL951pEVAB9wEHgPefyhjU+Ab7MqsmyThWUtU4PAueBb5urpOJTR668c0etWOoZXb5tfK42/RDwMPAE8DSwUlLEQBHmjLVOSwJQwIC8tBHgYhO00JhXh4+/XTxqdl7YtOzerd+cnHwRJtE6rQO/AmWB3g+cbH0He4ATgAWOSNkLzuU0VyXqu3F0y+hbP9YuPA/stsbfAzC19H2jQQN3KZ+3xo+I/h+FjREB48CTwFZgBzDXpn3LsSon+2d3nRD8F9b4vTsHXti4pjTc8/6I2wt8DTSAl6zxWjzzV6Jp4A95Lnbo1mKwdFMpO5NMAJki2n57752fjQ/suXVlafWDwFPAPOCBT6zxW7JqgtI6nQXGgNeBbVLidkm6XIhrwMdABrw5U5t6NlLRZr/x7LHjV8+Us2pyVWS5G/hQiHqAx+Ig0aZAmt+AGaAinbFCumMReGRNPHQUOKzeVX3AtcAvp6zxo8BXIterodZhe/UDw8DNkrwceKaQi8StxpR59QNwF3AZmIhbDNd8/g5UgVVy67Gg686JBKqd44XkInBbaLRFoBdYkn0FeFzMZERPgBuA+8SIqtNYCYddJMAp53IleitAOZfPOJf/5Fw+HY4W5/JfRN+O0ZxdYQX/Zmx3Ff9Z4v+doNA6Hf4nbYGG1un6cJR3Q1AAq4HTQlD8DX4e+Fw8UnRLoIAZ5/JBuZlqc7i573cuvwX4rlObtkYsPb5B6/SaOHctsF7rtBLg1spap3XaC2wAYufyrgheAz6QmVLIB+TTlhu2/l4BXummgj8BEM0iRsR/U1QAAAAASUVORK5CYII=";
        var fileGuideIcon = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH4QUIEw0mZVsjgQAAAiNJREFUSMet1UuoTWEYBuDnuHXqJOUSJbkdMqBcimgN1lbCYBkYSJKJONIaiMiAoZEYLTnuTBQysUaS9o5FBsdQESdCUuRSrh1sk/9ot8M+e/FOVutf//re/3u/73v/Dg2I48oZrMMXQ8MwjMa2Wq168ncbOpoI6liN/uZvf8BYnMZ0HKrVqvuaN4xoev+O/lqt+nAox4/jyni8CVlfi+OKZpJhrbJqgQ6MxDeswK44rmxvRdAOvuETzqEXj3HkbxK1i3dYG+LU0Y2iFEGWF/NwFh+xMU2ip7VatY63DTUZG4hKSbQzBOtCz1B/GjGEk0/ARcT4EAq7MMuLOdiQJtHXVoPyt+CL8AivMArncSD0/0Q8yfJiaimCLC+6cAr70yRalybRAPbiMBbjGa7jVJYXnWUkWoXXONawNh0nsCDUYwpuYS762pVoLe7gR8hoB+7ifnhuDZPfhzVlajAZm7E0y4vR2BQCj8MArmB9OMikMgQvcDxNohuhLd/iJVbiSKjJBVwK623X4DJ6srwYg4NBjtuYnSbRoBmOwhJsKZPB1SDH0TDBy4OVP2/Ysxvvca/tDNIk+pDlRQ+qgezmoKFledEb5JmPZWkSfS41aGkS9WFWKOLH4Pt7guafMS1Nov5/soo0iV4iyvKiGzNC2z5Ik+jZf/GiBqJHwTbawu8kqv/D/VBvlcFwzIzjSrtX52Dwmc0xmwnOhv7/UjKDzhDjF34CWgai1qHbevcAAAAASUVORK5CYII=";
        var favoriteIcon = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAQCAYAAADJViUEAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH4QUJERQ2WNQp9gAAAB1pVFh0Q29tbWVudAAAAAAAQ3JlYXRlZCB3aXRoIEdJTVBkLmUHAAABqklEQVQoz62RsWsUURDGf/N235ndyyWKIgFFRLRSsJGIIcQVS1FXbKKdhY2FjZap7j8Qgv4RgrkUClqthcTCysrGIiKImCuMe3uSt++NRU449bYQnfKb3/fNDAP/UNLUcOvn51B5BNy2ebE1iTGNsSoLQC7CuSak2SzalXSI87r8V2bXy04Q+ZNm/1eC6OKb1ezwxHzXy44AHWB2pJUE6crM4Gp0sE/96QBlf3olmfIvIoMFFNgGvojrZd+BeCSCKAKRzG0JtoZqD9rfF1QljA2NgPcxcBxhTabLM9KpwIyYYMDF0PLIoc9GwFBHaNn2+i19jnBLANyTix0IK9j6vulUhpb788BhizBIS1zcxfpVe+Xl8Jc/u7ULlzD+sdlbJhgda8SE7fYmyrK9Vrz+Kce/5W9KpE69SQgKQdgNUTDq8eZd86tEbyJhhmDQKkHLNjqc2r3fhGOInppodk8zAyyBoIPU4+INVBbZsW+pEj/C7kye7JgHzqqLP6LctXmxYPPilc2L0ztO7mkdfQBuNK09CzwDlmxePByH0uvFg7rmMrDhetlR/kf9AEo0oOBD+NQHAAAAAElFTkSuQmCC";
        var saveSearchIcon = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAOCAYAAAA1+Nx+AAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH4QUIDzUWQSH1wgAAAB1pVFh0Q29tbWVudAAAAAAAQ3JlYXRlZCB3aXRoIEdJTVBkLmUHAAACO0lEQVQ4y53TT4hVZRgG8N937j1NoqNJSSE6QQ2zESTBhROzOC5kihAPGFiLYghp0SIPCkK7IEEEk1ubNjERRKQFHWgzSOUxkiSNyKigBOOQRkIFFeHMuXNui3uufxhvii98fHy8z/s8778vuAMb6/RaeA6PYxw1fsBHZRbevR4b7oB8GnO3gG0us/AVRFWebK3y5InbJH8ec3WP5TEPrGDlCHVvCfTsWKe3BUKVJ1/g3jgtJv6HGEbxV91j5hFeSa753/yal0/SWtqPFRF6t8q8zAJ8DI+N98lPX2Rylve/Z/cm9j9609D9ES5j2W10aGK+y9MbuPQ3Tx7r3y/O8eVFph/mSndJzK42TmJHlSftOC26VZ7AGtyFS3FaDCpcCaFpQ41W41ioh27LRITZ5vEjxGkBH+IXbG0EIYy0Ofoda0eZ3c74ag5vY2o9n1zg7vYSgX4+VZ7sxAc4g224gnOYwHScFsfHOr0/cU+3Zu8k+7ZcY1lY7N87j3Hu8g0CP4UqT8RpocqTGbzVOD7HBTwDLYvJgz9/djAwCYs1cYsNazj/B1XNiWdZv4od7/HNb1cFDgwqGIhEeA1TuA/rGmBn5PyJQ+vafh22Ae2oLzK2iodeZ7E/ufuH/uQqTzrYg7fjtJhp/sNevDospu6xLGa+v01TZRZORUPI32nI34jTYmYw6DILR/AUFm4WFwXmu/7BxjILpyAaksynyOK0eOG6zRrY0TILI3gJ/6LbnN+xu8zCaJmFbwfg/wBBRLrBmxJQiwAAAABJRU5ErkJggg==";
        var fileGuideItemIcon = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAUCAYAAABvVQZ0AAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAA3rAAAN6wFCYyVRAAAAB3RJTUUH4AcVFS8K51N6dwAAAB1pVFh0Q29tbWVudAAAAAAAQ3JlYXRlZCB3aXRoIEdJTVBkLmUHAAADbElEQVQ4y4WUbWjVZRjGf/ezs7lXzQmrqJXGpM3/yURCkF6Ywl5PaxI4etsHzRIkqZ3/wT5U478worG3tjCCMiWK2KHS6c7ZPs1gsAoq2s5ZVDKFqCnWxB3d5pnnufuwrM7Y2v3xvp/neu77eu7rEpYLRZxosFGQShVi17ILus7v8ObSjqimXfEth+VEQ3tAP1C4iPJ03sx0CbCP/wmzfEnrEc5BcqcIvYjUsULI4kTZwEvrTCojhJHnUF33n1IS9LhR7RkLdI6tCLYp4h4UeBPIQnUINT9j9AVBwmBRpArIR3iXREEw3uAllxzT6XfbBbqBIWNtaTzQUYXIG4C1ysex2o6GzOupu0G7UQ5QkBgoiRxctQTZ7rNOxFV/xO1G07vdHDl05+Kcv99tdCKudfqD76eN6Qw0FWLNWeC7+DcFlXieXYqPcu9cdqaZOQDsV5uqmdx27HmQQ0bkwbGathEAn1jZq7BWRIJLAZV7Qz6fufUpYcYDNgC/X1u9dpKcucPM5u61qkFg99+cSR3KD7GattHFQFWH4/WZpmhc0PcQ+WphlXl9JFg8G99x5CroF0C10+tlAhhV3YzRaX80+Mz6IS/7JlCFF99iLZ+julFF6lTtZYGJqaLZowD+qPs4Qo5Cvim8UrygAMMaVB5WeChvLnEeGF74Z3lL0F9UZKNRPamIT1X2fbv/gXlnoKlQLZ8CmQIwL6XAhFHMJKqfWZO6I17TPgxQ2TJeAVqRwuxBOK6QC3LhlrKyTwDi1Z1TGHubUV4DUMPYwvswisj9P1Z3TQJ4nho12gpcysB+hLLbWGnNycjeFm6Q1E0a4tWdU1a0DPiz7Mqvvy1whj0BlPijoXKAYTP+BMoWIBcIz1vfhkFv08t9r9xzMW3/BkNFII8J9IUbwhbAtyahR6fz5VW12rW9t2m7+YkLWFqS6nvnjHfvH8uJ+sYN2kXIlgxa07Tp7w8+qiInET21OqFPjjR0zv4j/H73kXlJfn22tuf6vz7nekCzqLTEAm1emjZjgY7TIC+iUjedZ0acSGgngH8wWGyEL7N0VT3AfYNuqRN1+4BmlGOx2raWZV3DPxAKqLVHQO4CJlQZFWEXcAahAGUrkBClORZof3tFP1s/5GXlz11tVNVdwFbgduAyqnFETmeR/PD72p5LS/H4F0wrbFrsPsukAAAAAElFTkSuQmCC";
        var workAreaIcon = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAN1wAADdcBQiibeAAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAAIeSURBVEiJ7ZPPS1RRFMc/576eY4PY0ihbRRFFUE2LFGTuOEGZtBSMaNkiaF9Lg/4CQWgRErRoIbSpkMYZ3nuTQZDUolXhzhS1IKrFODD3nhYqOOPIyKC16bu6P879fu455174r38tabaYz+dPOucnVTlrDK+DILhdLBZ/tgMwzRadc09An6XTnce853etVhtrx3xHAMi5arU6OT09/UtEn4Kc32OAzqVSqeGNyTDo+3YBB5raa3BPxD+3NjcKXADtbxfQtMkA1tpTItIfhuHLQqGwumeAoaGhVKVSGRWR+SiK3q7DBu+r6gMROloZquJFKIBej+O4VleifD7fU6msJaqy4r27u+XYTVV3KUnKH1sBRkZGgtXV71+MkePA57omO6d3RCgkSZQtl8ufttzKhGFYbWUOMDU15YA1Y0wADa9IVU8A73ZjtFs1PtPDIrK8rwBVXdlLQF2TRegxxrTMoK+v72BHR+eyCN2qeDBXk6Q00yx2SwZjBjhUKg38aAwSEeecS2/OwzDsFeFbHEdiDBMi7vTmXiaTCUVIA7VGgAcWs9nyFRr+h4g+Bpm1NqfWDj4MguAI6BKA9ywAvdbai9bmal1d3WuqfCiVBua3lUjV3AL/yNrcqw2Igl6LomgcGN+My2YHb4iwtIH/CmTiOJqr94vYBkiS0hvgTLNa1mfEUVUW18d+AaR3x9iJF7MzCpdbmbYjgeJ++P5d/QGi+MPAC1BY6QAAAABJRU5ErkJggg==";


        sidebarservice.activeMenuItem = null;
        sidebarservice.menuItems = [];
        $scope.$watch(function () {
            return vm.loginService.resourceStrings;
        }, function () {
            sidebarservice.menuItems = [{
                id: 1,
                name: vm.loginService.resourceStrings["HOME"],
                opened: false,
                icon: homeIcon,
                action: function () {
                    breadCrumbService.category = "";
                    $state.go("layout.home");
                }
            }, {
                id: 2,
                name: vm.loginService.resourceStrings["FAVORITES"],
                opened: false,
                icon: favoritesIcon,
                action: getFavorites,
                editAction: editFavorite,
                optionMenu: [{
                    id: 1,
                    name: loginService.resourceStrings['CREATE_NEW'],
                    action: addFavorite,
                    disabled: false,
                    icon: ["glyphicon", "glyphicon-plus"],
                }],
                itemMenu: [{
                    id: 1,
                    name: loginService.resourceStrings['ADD_ITEMS'],
                    action: addToFavorite,
                    disabled: true,
                    icon: ["glyphicon", "glyphicon-plus"],
                }, {
                    id: 2,
                    name: loginService.resourceStrings['RENAME'],
                    action: editItem,
                    disabled: false,
                    icon: ["glyphicon", "glyphicon-edit"],
                }, {
                    id: 3,
                    name: loginService.resourceStrings['DELETE'],
                    action: deleteFavorite,
                    disabled: false,
                    icon: ["glyphicon", "glyphicon-trash"],
                }, {
                    id: 4,
                    name: loginService.resourceStrings['REMOVE_ITEMS'],
                    action: deleteFavoriteItems,
                    disabled: favRemoveItemsDisabled,
                    icon: ["fa", "fa-ban"],
                }],
            }, {
                id: 3,
                name: vm.loginService.resourceStrings["SAVED_SEARCHES"],
                opened: false,
                icon: savedSearchesIcon,
                action: getSavedSearches,
                editAction: editSavedSearch,
                optionMenu: [{
                    id: 1,
                    name: loginService.resourceStrings['CREATE_FROM_LAST_SEARCH'],
                    action: addSavedSearch,
                    disabled: false,
                    icon: ["glyphicon", "glyphicon-plus"],
                }],
                itemMenu: [{
                    id: 1,
                    name: loginService.resourceStrings['RENAME'],
                    action: editItem,
                    disabled: false,
                    icon: ["glyphicon", "glyphicon-edit"],
                }, {
                    id: 2,
                    name: loginService.resourceStrings['DELETE'],
                    action: deleteSavedSearch,
                    disabled: false,
                    icon: ["glyphicon", "glyphicon-trash"]
                }],
            }, {
                id: 4,
                name: vm.loginService.resourceStrings["INBOX"],
                opened: false,
                icon: inboxIcon,
                tree: true,
                action: fileGuideMenuSelected,
            }, {
                id: 5,
                name: vm.loginService.resourceStrings["LIBRARY_BROWSER"],
                opened: false,
                icon: libraryBrowsericon,
                children: [],
                tree: true,
                action: fileGuideMenuSelected,
            }, {
                id: 6,
                name: vm.loginService.resourceStrings["FILE_GUIDE"],
                opened: false,
                icon: fileGuideIcon,
                children: [],
                action: function (item) {
                    sidebarservice.activeMenuItem = item;
                    item.children = vm.sidebarservice.sideMenuItems.fileGuide.items;
                    item.children.forEach(function (child) {
                        child.tree = true;
                        child.action = fileGuideMenuSelected;
                        child.icon = fileGuideItemIcon;
                    });
                },
                //}, {
                //    id: 7,
                //    name: vm.loginService.resourceStrings["SUPPORT_LIBRARIES"],
                //    opened: false,
                //    icon: fileGuideIcon,
                //    children: [],
                //    action: getSupportLibraries
            }, {
                id: 7,
                name: vm.loginService.resourceStrings["WORK_AREAS"],
                hide: !loginService.creator,
                creator: loginService.creator,
                opened: false,
                icon: workAreaIcon,
                children: [],
                action: getWorkAreas,
                optionMenu: [{
                    id: 1,
                    name: loginService.resourceStrings['CREATE_NEW_WORK_AREA'],
                    action: addWorkArea,
                    disabled: false,
                    icon: ["glyphicon", "glyphicon-plus"],
                }],
                itemMenu: [
                    {
                        id: 1,
                        name: loginService.resourceStrings['SHOW_IN_WINDOWS_EXPLORER'],
                        action: showInWindowsExplorer,
                        disabled: false,
                        icon: ["glyphicon", "glyphicon-folder-open"],
                    }, {
                        id: 2,
                        name: loginService.resourceStrings['EDIT'],
                        action: editWorkArea,
                        disabled: false,
                        icon: ["glyphicon", "glyphicon-edit"],
                    }, {
                        id: 3,
                        name: loginService.resourceStrings['DELETE'],
                        action: deleteWorkArea,
                        disabled: false,
                        icon: ["glyphicon", "glyphicon-trash"],
                    }]
            }];
        });


        $scope.$watch(function () {
            return vm.loginService.creator;
        }, function (value) {
            var workAreaItem = $filter('filter')(sidebarservice.menuItems, { id: 7 });
            workAreaItem.hide = !value;
        })



        //back to menu
        vm.backToMenu = function () {
            if (sidebarservice.activeMenuItem == vm.previousItem) {
                sidebarservice.activeMenuItem = null;
            }
            else {
                sidebarservice.activeMenuItem = vm.previousItem;
            }
        }

        //menu items  JM - Revise this, we may not need it anymore.
        vm.toggleMenu = function (menuItem) {

            for (var item in vm.sidebarservice.sideMenuItems) {
                if (item == menuItem)
                    vm.sidebarservice.sideMenuItems[item].active = !vm.sidebarservice.sideMenuItems[item].active;
                else
                    vm.sidebarservice.sideMenuItems[item].active = false;
            }
        }

        vm.editInputKeyPress = function (event, item) {
            if (event.keyCode == 13 || event.keyCode == 27) {
                vm.inputBlur(item);
            }
        }

        vm.inputBlur = function (item) {
            var duplicate = false;
            if (!item.name) {
                showToast(loginService.resourceStrings['NAME_CANNOT_BE_EMPTY']);
                item.name = oldName;
                return;
            }

            vm.sidebarservice.activeMenuItem.children.forEach(function (child) {
                if (item.id != child.id) {
                    if (item.name.toLowerCase() == child.name.toLowerCase() && item.userId == child.userId) {
                        item.name = oldName;
                        showToast(loginService.resourceStrings['NAME_ALREADY_EXISTS']);
                        duplicate = true;
                    }
                }
            });

            item.editEnabled = duplicate;
            $timeout(function () {
                vm.editMode = duplicate;
            }, 1000);

            if (!duplicate) {

                sidebarservice.activeMenuItem.editAction(item);
            }

        }

        function editItem(item) {
            oldName = item.name;
            item.editEnabled = true;
            vm.editMode = true;
        }

        function showToast(message) {
            $mdToast.show({
                hideDelay: 1000,
                position: 'bottom right',
                parent: document.getElementById("zhgTur"),
                template: '<md-toast><span class="md-toast-text" flex>' + message + '</span></md-toast >',
            });
        }

        // ************************************************
        // MenuView - End
        // ************************************************

        // ************************************************
        // Favorites - Start
        // ************************************************
        function getFavorites(item) {
            sidebarservice.activeMenuItem = item;
            vm.previousItem = null;
            getFavoritesDefinitions(false, item);
        }

        function getFavoritesDefinitions(force, favorite) {
            var deferred = $q.defer();
            vm.favoritesService.onRefresh = function (items) {
                angular.forEach(items, function (item, value) {
                    item.active = false;
                    item.action = getFavoriteRecords;
                    item.icon = favoriteIcon;
                    item.itemMenu = angular.copy(favorite.itemMenu);
                    item.editable = item.userId == vm.loginService.id;
                });
                if (sidebarservice.activeMenuItem && sidebarservice.activeMenuItem.id == 2) {
                    sidebarservice.activeMenuItem.children = items;
                }
            }

            favoritesService.getDefinitions(force).then(function (definitions) {
                angular.forEach(definitions, function (item, value) {
                    item.active = false;
                    item.action = getFavoriteRecords;
                    item.icon = favoriteIcon;
                    item.itemMenu = angular.copy(favorite.itemMenu);
                    item.editable = item.userId == vm.loginService.id;
                });
                vm.sidebarservice.sideMenuItems.favorites.items = definitions;
                sidebarservice.activeMenuItem.children = vm.sidebarservice.sideMenuItems.favorites.items;
                deferred.resolve();
            });
            return deferred.promise;
        }

        //get the favorite records and show them in the grid
        function getFavoriteRecords(favorite) {
            fileGuideService.clearSelectedNodes();
            if (!vm.editMode) {
                //clear the criteria first
                vm.criteria.valueStr = "";
                //set the favorites service current item
                favoritesService.currentItem = favorite;
                //set the grid's data service serivce identifier to be the favorite service
                gridDataService.serviceIdentifier = "favoritesService";
                //set the totalRecords to 0 which identifies this search as a new search
                gridDataService.totalRecords = 0;
                gridDataService.processing = true;
                //display the grid
                $timeout(function () {
                    $state.go('layout.results.grid').then(function () {
                        gridDataService.reloadGrid();
                    });
                })
            }
        };

        function addFavorite() {
            vm.editMode = true;
            var name = loginService.resourceStrings['NEW_FAVORITE'];
            var existing = $filter('filter')(vm.sidebarservice.sideMenuItems.favorites.items, { name: name });
            var nameNumber = "";
            if (existing.length > 0) {
                var i = 1;

                while (true) {

                    var existing = $filter('filter')(vm.sidebarservice.sideMenuItems.favorites.items, { name: name + nameNumber }, true);
                    if (existing.length > 0) {
                        nameNumber = i;
                        i++;
                    }
                    else {
                        break;
                    }
                }

            }
            var favoriteMenu = $filter('filter')(sidebarservice.menuItems, { id: 2 })[0];
            name = name + nameNumber;

            //Bill 02-19-2018 #24597 nAWC-Favorites and Saved Searches auto created comments use User Login-should use User Name
            //     use loginService.userName rather than .loginName
            var comment = loginService.resourceStrings['NAMED_DOCUMENT_LIST_MADE_BY'] + " " + loginService.userName + " " + loginService.resourceStrings['ON'] + " " + new Date().toDateString();

            vm.favoritesService.addFavoriteList(name, comment).then(function (response) {
                var item = {
                    icon: favoriteIcon,
                    action: getFavoriteRecords,
                    active: false,
                    comment: comment,
                    name: name,
                    editable: true,
                    editEnabled: true,
                    itemMenu: angular.copy(favoriteMenu.itemMenu),
                    id: response.containerDefinition.id,
                    userId: loginService.id
                };
                vm.sidebarservice.sideMenuItems.favorites.items.unshift(item);
                oldName = name;
                if (gridDataService.selectedRows.length > 0 && $state.current.name == "layout.results.grid") {
                    addToFavorite(item);
                }
            });
        }

        function editFavorite(item) {
            favoritesService.editFavoriteList(item.id, item.name, item.comment).then(function () {
                vm.sidebarservice.sideMenuItems.favorites.items = $filter('orderBy')(vm.sidebarservice.sideMenuItems.favorites.items, "name", false);
                getFavoritesDefinitions(true, sidebarservice.activeMenuItem).then(function () {
                    sidebarservice.activeMenuItem.children = vm.sidebarservice.sideMenuItems.favorites.items;
                    showToast(loginService.resourceStrings['ITEM_EDITED']);
                });
            }, function () {
                getFavoritesDefinitions(true, sidebarservice.activeMenuItem).then(function () {
                    sidebarservice.activeMenuItem.children = vm.sidebarservice.sideMenuItems.favorites.items;
                });
            });
        }

        function deleteFavoriteItems(item) {
            favoritesService.deleteItemsFavorite(item.id, gridDataService.selectedRows).then(function () {
                showToast(gridDataService.selectedRows.length + ' ' + loginService.resourceStrings['ITEMS_DELETED_FROM'] + ' "' + item.name + '"');
                gridDataService.reloadGrid();
            });
        }

        function deleteFavorite(item) {

            vm.favoritesService.deleteFavoriteList(item.id).then(function myfunction() {
                var index = vm.sidebarservice.sideMenuItems.favorites.items.indexOf(item);
                vm.sidebarservice.sideMenuItems.favorites.items.splice(index, 1);
                sidebarservice.activeMenuItem.children = vm.sidebarservice.sideMenuItems.favorites.items;
                showToast(loginService.resourceStrings['ITEM_DELETED']);
                getFavoritesDefinitions(true, sidebarservice.activeMenuItem);

            });
        }


        function addToFavorite(item) {
            favoritesService.addItemsFavorite(item.id, gridDataService.selectedRows).then(function () {
                showToast(gridDataService.selectedRows.length + ' ' + loginService.resourceStrings['ITEMS_ADDED_TO'] + ' "' + item.name + '"');
            });
        };
        // ************************************************
        // Favorites - End
        // ************************************************

        // ************************************************
        // Saved Searches - Start
        // ************************************************

        //saved search
        function getSavedSearches(item) {
            sidebarservice.activeMenuItem = item;
            vm.previousItem = null;
            getSavedSearchDefinitions(false, item);
        }

        function getSavedSearchDefinitions(force, savedSearch) {
            savedSearchService.getDefinitions(force).then(function (definitions) {
                angular.forEach(definitions, function (item, value) {
                    item.active = false;
                    item.action = getSavedSearch;
                    item.icon = saveSearchIcon;
                    item.itemMenu = angular.copy(savedSearch.itemMenu);
                    item.editable = item.userId == vm.loginService.id;
                });
                vm.sidebarservice.sideMenuItems.savedSearches.items = definitions;
                sidebarservice.activeMenuItem.children = vm.sidebarservice.sideMenuItems.savedSearches.items;
            });
        }

        //get the savesearch items
        function getSavedSearch(savedSearch) {
            //removeFileGuide();
            fileGuideService.clearSelectedNodes();
            //clear the criteria first
            vm.criteria.valueStr = "";
            savedSearchService.currentItem = savedSearch;

            savedSearch.active = true;

            //set the grid's data service service identifier to be the saved search service
            gridDataService.serviceIdentifier = "savedSearchService";
            //set the totalRecords to 0 which identifies this search as a new search
            gridDataService.totalRecords = 0;
            gridDataService.processing = true;
            $timeout(function () {
                $state.go('layout.results.grid').then(function () {
                    gridDataService.reloadGrid();
                });
            })
        };

        function addSavedSearch() {
            vm.editMode = true;
            var name = loginService.resourceStrings['NEW_SAVED_SEARCH'];
            var existing = $filter('filter')(vm.sidebarservice.sideMenuItems.savedSearches.items, { name: name });
            var nameNumber = "";
            if (existing.length > 0) {
                var i = 1;

                while (true) {

                    var existing = $filter('filter')(vm.sidebarservice.sideMenuItems.savedSearches.items, { name: name + nameNumber }, true);
                    if (existing.length > 0) {
                        nameNumber = i;
                        i++;
                    }
                    else {
                        break;
                    }
                }

            }

            name = name + nameNumber;

            var savedSearchMenu = $filter('filter')(sidebarservice.menuItems, { id: 3 })[0];

            //Bill 02-19-2018 #24597 nAWC-Favorites and Saved Searches auto created comments use User Login-should use User Name
            //     use loginService.userName rather than .loginName
            var comment = loginService.resourceStrings['SAVED_SEARCH_MADE_BY'] + " " + loginService.userName + " " + loginService.resourceStrings['ON'] + " " + new Date().toDateString();

            vm.savedSearchService.addSavedSearch(name, comment).then(function (response) {
                var item = {
                    icon: saveSearchIcon,
                    action: getSavedSearch,
                    active: false,
                    comment: comment,
                    name: name,
                    editable: true,
                    editEnabled: true,
                    itemMenu: angular.copy(savedSearchMenu.itemMenu),
                    id: response.containerDefinition.id,
                    userId: loginService.id
                };
                vm.sidebarservice.sideMenuItems.savedSearches.items.unshift(item);
                vm.sidebarservice.sideMenuItems.savedSearches.items = $filter('orderBy')(vm.sidebarservice.sideMenuItems.savedSearches.items, "name", false);
                vm.savedSearchService.definitions = vm.sidebarservice.sideMenuItems.savedSearches.items;
                oldName = name;
            });
        }

        function editSavedSearch(item) {
            savedSearchService.editSavedSearch(item.id, item.name, item.comment).then(function () {
                vm.sidebarservice.sideMenuItems.savedSearches.items = $filter('orderBy')(vm.sidebarservice.sideMenuItems.savedSearches.items, "name", false);
                sidebarservice.activeMenuItem.children = vm.sidebarservice.sideMenuItems.savedSearches.items;
                vm.savedSearchService.definitions = vm.sidebarservice.sideMenuItems.savedSearches.items;
                showToast(loginService.resourceStrings['ITEM_EDITED']);
                getSavedSearchDefinitions(true);
            });
        }

        function deleteSavedSearch(item) {
            savedSearchService.deleteSavedSearch(item.id).then(function () {
                var index = vm.sidebarservice.sideMenuItems.savedSearches.items.indexOf(item);
                vm.sidebarservice.sideMenuItems.savedSearches.items.splice(index, 1);
                sidebarservice.activeMenuItem.children = vm.sidebarservice.sideMenuItems.savedSearches.items;
                vm.savedSearchService.definitions = vm.sidebarservice.sideMenuItems.savedSearches.items;
                showToast(loginService.resourceStrings['ITEM_DELETED']);
                getSavedSearchDefinitions(true);
            });
        }

        // ************************************************
        // Saved Searches - Start
        // ************************************************

        // ************************************************
        // FileGuide - Start
        // ************************************************

        //get fileguide list
        fileGuideService.getFileGuideList().then(function (data) {
            vm.sidebarservice.sideMenuItems.fileGuide.items = [];
            for (var item in data) {
                vm.sidebarservice.sideMenuItems.fileGuide.items.push({ id: item, name: data[item], active: false });
            }
        });

        //when picking a fileguide item
        vm.treeData = [];
        vm.currentViewLabel = "";
        function fileGuideMenuSelected(item) {
            sidebarservice.activeMenuItem = item;
            vm.fileGuideService.title = item.name;
            vm.fileGuideService.showFilter = true;
            vm.fileGuideService.currentQuery = "";
            switch (item.id) {
                case 5:
                    // Library Browser Selected
                    vm.previousItem = null;
                    vm.fileGuideService.mode = 1;
                    vm.fileGuideService.title = loginService.resourceStrings["LIBRARY_BROWSER"];

                    // Unselect anything selected in the FileGuide
                    vm.fileGuideService.clearSelectedNodes();

                    //set the function to call when an item is picked
                    fileGuideService.currentAction = fileGuideService.libraryPicked;
                    //get the tree from the library service
                    fileGuideService.getLibraryTree().then(function (data) {
                        //set the fileguide tree
                        fileGuideService.tree = data;
                    });
                    break;
                case 4:
                    // Inbox Selected
                    vm.previousItem = null;
                    vm.fileGuideService.mode = 2;
                    vm.fileGuideService.title = loginService.resourceStrings["INBOX"];
                    vm.fileGuideService.showFilter = false;

                    // Unselect anything selected in the FileGuide
                    vm.libraryService.clearSelectedNodes();
                    vm.fileGuideService.clearSelectedNodes();

                    //set the function to call when an item is picked
                    fileGuideService.currentAction = fileGuideService.inboxNodePicked;

                    fileGuideService.getInboxTree().then(function (data) {
                        fileGuideService.tree = data;
                    });
                    break;
                default:
                    // FileGuide Selected
                    vm.previousItem = $filter("filter")(sidebarservice.menuItems, { name: vm.loginService.resourceStrings["FILE_GUIDE"] })[0];
                    vm.fileGuideService.mode = 3;

                    // Unselect anything selected in the FileGuide
                    vm.fileGuideService.clearSelectedNodes();

                    fileGuideService.currentAction = fileGuideService.fileGuideItemPicked;
                    fileGuideService.getFileGuideTree(item).then(function (data) {
                        //var templateItem = JSON.parse(JSON.stringify(data[0]));
                        //for (var i = data.length + 50; i < 3000; i++) {
                        //    templateItem.uniqueId = i;
                        //    var item = JSON.parse(JSON.stringify(templateItem));;
                        //    data.push(item);
                        //}
                        fileGuideService.tree = data;
                    });

                    break;
            }

            //sidebarservice.fileGuideCollapse = true;
            if (sidebarservice.fileGuideCollapse) {
                sidebarservice.showDataToolBox = true;
            }

            sidebarservice.leftSideBarCollapse = false;
        }

        //set navigation items inactive when picking one.
        var setInactive = function () {
            vm.savedSearchService.resetActive();
            vm.favoritesService.resetActive();
        }

        //when the filter input changes
        vm.textChanged = function (query) {
            //property to filter by
            var prop = "name"; //default
            if (sidebarservice.activeMenuItem.id == 5 && fileGuideService.showFolder) {
                prop = "folder";
            }
            fileGuideService.filterTree(query, prop);
        }

        //set the fileguide data are to hidden by default.
        vm.showDataToolBox = false;

        // ************************************************
        // FileGuide - End
        // ************************************************

        //opens the document dashboard
        vm.openDD = function () {
            ddService.opened = true;
        }

        // datacard search listener
        vm.dataCardSearch = function () {
            //removeFileGuide();
            if ($state.current.name !== 'layout.searchcard') {
                $state.go('layout.searchcard');
            }
        }

        vm.openMenu = function ($mdMenu, ev, item) {
            //enabled/disable the add to favorite button
            if (sidebarservice.activeMenuItem.id == 2 && item) {
                $filter("filter")(item.itemMenu, { id: 1 })[0].disabled = gridDataService.selectedRows.length == 0 || $state.current.name != "layout.results.grid";
                //console.log(item);
                //console.log(breadCrumbService.node);
                if (item) {
                    if (breadCrumbService.node && (gridDataService.selectedRows.length > 0 && $state.current.name == "layout.results.grid")) {
                        $filter("filter")(item.itemMenu, { id: 4 })[0].disabled = breadCrumbService.node.id != item.id;
                    }
                    else {
                        $filter("filter")(item.itemMenu, { id: 4 })[0].disabled = true;
                    }
                }
            }


            $mdMenu(ev);
        };

        $scope.$watch(function () {
            return sidebarservice.leftSideBarCollapse;
        }, function (value) {
            vm.sidebarOpened = !value;
        });

        $scope.$watch(function () {
            return sidebarservice.leftSideBarOpen;
        }, function (value) {
            vm.sidebarOpened = value;
        });

        function generateUUID() {
            var d = new Date().getTime();
            if (window.performance && typeof window.performance.now === "function") {
                d += performance.now(); //use high-precision timer if available
            }
            var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                var r = (d + Math.random() * 16) % 16 | 0;
                d = Math.floor(d / 16);
                return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16);
            });
            return uuid;
        }

        // ************************************************
        // Support Libraries - Begin
        // ************************************************
        /*
        function getSupportLibraries(item) {
            sidebarservice.getSupportLibraries().then(function (definitions) {
                vm.sidebarservice.sideMenuItems.supportLibraries = {};
                vm.sidebarservice.sideMenuItems.supportLibraries.items = [];
                angular.forEach(definitions, function (item, value) {
                    item.active = false;
                });
                vm.sidebarservice.sideMenuItems.supportLibraries.items = definitions;
                item.children = vm.sidebarservice.sideMenuItems.supportLibraries.items;
            });
            sidebarservice.activeMenuItem = item;
        }
        

        //vm.fileGuideMenuSelected = function (item) {

        //};

        // Callback from the input box before the box closes.
        var supportLibraryInputBoxPreClosePromiseCallback = function (param1, param2, bOK, edit1, edit2) {
            var deferred = $q.defer();
            if (bOK) {
                sidebarservice.setSupportLibraryMapping(param1, edit1).then(function (data) {
                    deferred.resolve(data); // True to close.
                }, function (response) {
                    $rootScope.msgBoxShow(response.data.Message, loginService.resourceStrings["ERROR"]);
                    deferred.reject(response); // False to stop the close.
                });
            }
            else {
                deferred.resolve(); // True to close (after a Cancel).
            }
            return deferred.promise;
        }


        vm.onEditSupportLibrary = function (item) {
            var libId = item.libId;
            var name = item.name;
            sidebarservice.getSupportLibraryMapping(libId).then(function (data) {
                var title = loginService.resourceStrings["EDIT_SUPPORT_LIBRARY_PATH"]; // "Edit Support Library Mapping for {0}";
                title = title.replace("{0}", name); //title.concat(name);
                var prompt1 = loginService.resourceStrings["MAPPED_PATH"]; // "Mapped Path";
                var driveType = ' '; // not used.
                // Show the UI.
                //$rootScope.inputBoxShow(libId, "", title, prompt1, "", data, null, supportLibraryInputBoxPreClosePromiseCallback);
                $rootScope.browseFolderBoxShow(libId, "", title, prompt1, "", data, driveType, "", "", supportLibraryInputBoxPreClosePromiseCallback, null, 0);
            });
        };
        */
        // ************************************************
        // Support Libraries - End
        // ************************************************


        // ************************************************
        // Work Areas - Begin
        // ************************************************

        function getWorkAreas(item) {
            vm.loadingIndicator = true;
            vm.sidebarservice.sideMenuItems.workAreas = {};
            vm.sidebarservice.sideMenuItems.workAreas.items = [];
            // obsolete? - vm.sidebarservice.sideMenuItems.selectedWorkArea = {};

            

            workAreaService.getWorkAreas(true).then(function (workAreaModels) {

                angular.forEach(workAreaModels, function (workAreaModel, value) {
                    workAreaModel.active = false;
                    workAreaModel.action = getWorkAreaItems;
                    workAreaModel.editable = true;
                    workAreaModel.itemMenu = angular.copy(item.itemMenu);

                    // What shows in the tooltip for the info 'i'.
                    workAreaModel.comment = workAreaModel.pathLocal;

/*
                    // Move tooltip based on the size of the window
                    var viewportWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
                    // Take the length of the string and multiply by the font size
                    if (viewportWidth <= workAreaModel.path.length * 11) {
                        workAreaModel.direction = 'bottom';
                    }
                    else {
                        workAreaModel.direction = 'right';
                    }
                    //console.log('sidebar : ' + workAreaModel.direction + " : " + workAreaModel.path);
*/
                    //disable all menus except for show in explorer for shared work areas
                    if (workAreaModel.shared != " ") {
                        workAreaModel.itemMenu.forEach(function (obj, index) {
                            obj.disabled = obj.id != 1;
                        });
                    }
                });

                vm.sidebarservice.sideMenuItems.workAreas.items = workAreaModels;
                item.children = vm.sidebarservice.sideMenuItems.workAreas.items;
                sidebarservice.activeMenuItem = item;
                vm.loadingIndicator = false;
            });
        }

        function getWorkAreaItems(item) {
            //removeFileGuide();
            fileGuideService.clearSelectedNodes();
            //clear the criteria first
            workAreaService.currentWorkArea = item;

            //set the grid's data service service identifier to be the saved search service
            gridDataService.serviceIdentifier = "workAreaService";
            //set the totalRecords to 0 which identifies this search as a new search
            gridDataService.totalRecords = 0;
            gridDataService.processing = true;
            $timeout(function () {
                $state.go('layout.results.grid').then(function () {
                    gridDataService.reloadGrid();
                });
            })
        }

        // Callback from the input box before the box closes.
        var workAreaInputBoxPreClosePromiseCallback = function (param1, param2, bOK, edit1, driveType, edit2) {
            var deferred = $q.defer();
            if (bOK) {
                if (param2 == "add") {
                    var data = param1;
                    data.path = edit1;
                    data.type = driveType;
                    data.label = edit2;
                    //data.type = ''; // drive type
                    workAreaService.addWorkArea(data).then(function (data) {
                        deferred.resolve(data); // True to close.
                        getWorkAreas(sidebarservice.activeMenuItem);
                    }, function (response) {
                        // Exception already shown in http layer - $rootScope.msgBoxShow(response.data.Message, "Error");
                        deferred.reject(response); // False to stop the close.
                    });
                }
                else if (param2 == "edit") {
                    var data = param1;

                    data.path = edit1;
                    data.type = driveType;
                    data.label = edit2;
                    //data.type = ''; // drive type
                    workAreaService.setWorkArea(param1.workAreaId, data).then(function (data) {
                        deferred.resolve(data); // True to close.
                        getWorkAreas(sidebarservice.activeMenuItem);
                    }, function (response) {
                        // Exception already shown in http layer - $rootScope.msgBoxShow(response.data.Message, "Error");
                        deferred.reject(response); // False to stop the close.
                    });

                }
            }
            else {
                deferred.resolve(); // True to close (after a Cancel).
            }
            return deferred.promise;
        }

        // obsolete? - 
        // This was replaced by workAreaService.currentWorkArea
        //vm.workAreaMenuSelected = function (item) {
        //    vm.sidebarservice.sideMenuItems.selectedWorkArea = item;
        //}

        // Add button clicked.
        function addWorkArea() {
            var initialPath = "";
            // If a WA is selected, go up one folder and use a default path.
            if (workAreaService.currentWorkArea != null) {
                initialPath = workAreaService.currentWorkArea.path ? workAreaService.currentWorkArea.path : "";
                var len = initialPath.length;
                var char = initialPath.substr(len - 1, 1);
                if (char == "\\")
                    initialPath = initialPath.substr(0, initialPath.length - 1);
                var index = initialPath.lastIndexOf("\\");
                if (index > -1)
                    initialPath = initialPath.substr(0, index);
            }

            var title = loginService.resourceStrings["WORK_AREA_ADD"];
            var pathLabel = loginService.resourceStrings["PATH"];
            var labelLabel = loginService.resourceStrings["LABEL"];
            var data = {};
            data.path = "";
            data.type = ' '; // ApiTypes.WA_DRIVETYPE.WA_DRIVEUNKNOWN
            data.label = "";
            // Show the UI.
            $rootScope.browseFolderBoxShow(data, "add", title, pathLabel, labelLabel, data.path, data.type, data.label, initialPath, workAreaInputBoxPreClosePromiseCallback, null, 64);
        }

        function showInWindowsExplorer(item) {
            zcs.WindowsExplorer(item.path).then(function () {

            }, function (err) {
                //handled by http - $rootScope.msgBoxShow(err.data.ExceptionMessage, loginService.resourceStrings["SHOW_IN_WINDOWS_EXPLORER"]);
            });
        }

        // Callback from the input box after the box has closed.
        var copyFiles_ConfirmPostCloseCallback = function (param1, param2, bOK) {
            if (bOK) {
                zcs.CopyFiles(param1, param2);
            }
        }

        function editWorkArea_PostCloseCallback(param1, param2, bOK, edit1, driveType, edit2) {
            var origPath = $scope.editWorkAreaOrigPath;
            var newPath = edit1;
            // Was the path changed?
            if (bOK && origPath != newPath) {
                var title = loginService.resourceStrings["EDIT_WORK_AREA_COPY_FILES_TITLE"];
                var prompt1 = loginService.resourceStrings["EDIT_WORK_AREA_COPY_FILES_PROMPT1"];
                var prompt2 = loginService.resourceStrings["EDIT_WORK_AREA_COPY_FILES_PROMPT2"];
                $rootScope.confirmBoxShow(origPath, newPath, title, prompt1, prompt2, copyFiles_ConfirmPostCloseCallback);
            }
        }

        // Edit button clicked.
        function editWorkArea(item) {
            workAreaService.getWorkArea(item.workAreaId).then(function (data) {
                var title = loginService.resourceStrings["WORK_AREA_EDIT"];
                var pathLabel = loginService.resourceStrings["PATH"];
                var labelLabel = loginService.resourceStrings["LABEL"];
                title = title.concat(" - " + data.name);
                var continueOnAccessFailure = true;

                $scope.editWorkAreaOrigPath = data.path;

                // Show the UI.
                $rootScope.browseFolderBoxShow(data, "edit", title, pathLabel, labelLabel, data.path, data.type, data.label, "", workAreaInputBoxPreClosePromiseCallback, editWorkArea_PostCloseCallback, 64, continueOnAccessFailure);
            });
        };

        // Delete button clicked.
        function deleteWorkArea(item) {
            workAreaService.deleteWorkArea(item.workAreaId).then(function (data) {
                var workAreaModel = data;
                getWorkAreas(sidebarservice.activeMenuItem);
            });
        };

        // ************************************************
        // Work Areas - End
        // ************************************************

        vm.onResize = function () {
            gridDataService.refreshGrid();
        }

    }
})();
